/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
 */

import services from './services.js';

/**
 * Get an upload service implementation for a given interaction
 * @param {string} itemIdentifier - the item identifier
 * @param {string} responseIdentifier - the response id to identify the interactin
 * @param {Object} serviceParameters
 * @param {string} serviceParameters.id - the identifier of the upload service
 * @param {Object} [config] - shared upload configuration
 * @returns {Object} an upload service instance
 */
export default function getUploadService(itemIdentifier, responseIdentifier, serviceParameters = {}, config = {}) {
    const { id: serviceId } = serviceParameters;

    if (serviceId && typeof services[serviceId] === 'function') {
        //instantiate the factory
        return services[serviceId](`${itemIdentifier}_${responseIdentifier}`, serviceParameters, config);
    }
    throw new TypeError(`no upload service found with id '${serviceId}'`);
}
